var map = {
	"./CompanyLogoEdited-in.webp": 5994,
	"./CompanyLogoEdited.webp": 2838,
	"./Marco.jpg": 6004,
	"./PageNotFound.png": 7424,
	"./Priya.jpg": 983,
	"./Yuneli.jpg": 7892,
	"./bgImage.jpg": 9066,
	"./bgImage2.png": 4350,
	"./card-1.webp": 9789,
	"./card-2.webp": 6080,
	"./card-3.webp": 9123,
	"./card-4.webp": 6062,
	"./card-5.webp": 7097,
	"./home-cover.webp": 1176,
	"./mainImg.jpg": 4334,
	"./map.webp": 1710,
	"./researchMedia.png": 7551,
	"./services1.webp": 1744,
	"./services2.webp": 5453,
	"./services3.webp": 9890,
	"./services4.webp": 3708,
	"./services5.webp": 3084,
	"./services6.webp": 2761,
	"./welcomeImg-in.jpg": 1141,
	"./welcomeImg.jpg": 9193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4002;